import { useState } from 'react'

import { Box, Table, Text, colors } from '@factorialco/deprecated-design-system'

import { HeaderData } from 'modules/finance/components/FinancialWorkspace/types/table'

type Header = string | HeaderData

export const HeaderCell = ({
  header,
  colSpan,
  withBorder,
}: {
  header: Header
  colSpan?: number
  withBorder?: boolean
}) => {
  const [hover, setHover] = useState(false)

  const isReturnedData = (value: string | HeaderData): value is HeaderData =>
    typeof value === 'object' && value !== null && 'label' in value

  const isClickable = isReturnedData(header) && header.onClick

  return (
    <Table.HeadCell
      padding="s0"
      colSpan={colSpan}
      justifyContent="flexEnd"
      style={{
        borderRight: withBorder ? '1px solid #E2E2E5' : undefined,
      }}
    >
      <Box
        inline
        gap="s0"
        paddingY="s8"
        paddingX="s24"
        flexDirection="row"
        alignItems="center"
        borderRadius={{ all: 'abs004' }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        {...(isClickable && {
          onClick: () => header.onClick?.(header.value),
        })}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          width: 'max-content',
          border: `1px solid ${colors.grey200}`,
          ...(hover &&
            isClickable && {
              border: `1px solid ${colors.grey600}`,
            }),
        }}
      >
        <Text size="200" color="grey800" weight="medium">
          {isReturnedData(header) ? header.label : header}
        </Text>
      </Box>
    </Table.HeadCell>
  )
}
